import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const BlogListPage = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('Fetching blog post list...');
    const fetchBlogPosts = async () => {
      try {
        // Fetch the list of blog posts from the API
        const response = await axios.get('https://api.haulradar.com/v1/blog/blogposts/');
        console.log('Blog posts fetched:', response.data.data); // Log the data to verify
        setBlogPosts(response.data.data); // Store the list of blog posts in state
        setLoading(false); // Set loading to false after data is fetched
      } catch (err) {
        console.error('Error fetching blog posts:', err);
        setError('Failed to fetch the blog posts.');
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-200">
      {/* Main content wrapper with flex-grow to push footer to the bottom */}
      <div className="flex-grow container mx-auto px-6 py-10 mt-20">
        
        {/* Display loading, error, or the list of blog posts */}
        {loading ? (
          <p className="text-center text-gray-500">Loading blog posts...</p>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : blogPosts.length === 0 ? (
          <p className="text-center text-gray-500">No blog posts found.</p>
        ) : (
          <ul className="space-y-4">
            {blogPosts.map((post) => (
              <li key={post.id} className="bg-white p-6 rounded-lg shadow-md hover:bg-gray-100 transition">
                {/* Link to the individual blog post page */}
                <Link to={`/blog/${post.id}`} className="text-2xl font-semibold text-blue-600 hover:underline">
                  {post.title}
                </Link>
                <p className="text-gray-500">Published on: {new Date(post.created_at).toLocaleDateString()}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default BlogListPage;
